import { useEffect } from "react";
import { useGame } from "../header/GameContext";

import FooterButton from "../footer/footerButton";

import "./intro.css";

function Intro({ onFinish, defaultPath }) {
  const handleStart = async () => {
    onFinish?.({ defaultPath });
  };

  return (
    <div>
      <div className="intro_pop_box">
        <div className="intro_pop_tc">
          <div className="intro_img"></div>
        </div>
        <FooterButton ftIdName="box_ft3" onFinish={handleStart} />;
      </div>
    </div>
  );
}

export default Intro;
